const prefix = '@@seat-selection-orm';

const CREATE_HALL = `${prefix}/CREATE_HALL`;
const CREATE_GENERAL_ADMISSION = `${prefix}/CREATE_GENERAL_ADMISSION`;
const CREATE_SHAPE = `${prefix}/CREATE_SHAPE`;
const CALCULATE_HALL_POLYGON = `${prefix}/CALCULATE_HALL_POLYGON`;
const CALCULATE_SECTOR_SHELLS = `${prefix}/CALCULATE_SECTOR_SHELLS`;
const RESOLVE_SEAT_TRANSLATION = `${prefix}/RESOLVE_SEAT_TRANSLATION`;
const CALCULATE_GENERAL_ADMISSION_CACHE_KEY = `${prefix}/CALCULATE_GENERAL_ADMISSION_CACHE_KEY`;
const SELECT_SEAT = `${prefix}/SELECT_SEAT`;
const UNSELECT_SEAT = `${prefix}/UNSELECT_SEAT`;
const CHANGE_OBJECT_NAME = `${prefix}/CHANGE_OBJECT_NAME`;
const CHANGE_SHAPE_TYPE = `${prefix}/CHANGE_SHAPE_TYPE`;
const MOVE_OBJECT = `${prefix}/MOVE_OBJECT`;
const ROTATE_OBJECT = `${prefix}/ROTATE_OBJECT`;
const SET_OBJECT_CONFIGURATION = `${prefix}/SET_OBJECT_CONFIGURATION`;
const POP_SEAT = `${prefix}/POP_SEAT`;
const PUSH_SEAT = `${prefix}/PUSH_SEAT`;
const SHIFT_SEAT = `${prefix}/SHIFT_SEAT`;
const SHIFT_ROW = `${prefix}/SHIFT_ROW`;
const UNSHIFT_SEAT = `${prefix}/UNSHIFT_SEAT`;
const UNSHIFT_ROW = `${prefix}/UNSHIFT_ROW`;
const POP_ROW = `${prefix}/POP_ROW`;
const CHANGE_ROUND_TABLE_GAPS = `${prefix}/CHANGE_ROUND_TABLE_GAPS`;
const SET_TABLE_AUTO_SCALE = `${prefix}/SET_TABLE_AUTO_SCALE`;
const RESIZE_GENERAL_ADMISSION = `${prefix}/RESIZE_GENERAL_ADMISSION`;
const RESIZE_SHAPE = `${prefix}/RESIZE_SHAPE`;
const SET_GENERAL_ADMISSION_CAPACITY = `${prefix}/SET_GENERAL_ADMISSION_CAPACITY`;
const INCREMENT_GENERAL_ADMISSIONS_SEATS_USED = `${prefix}/INCREMENT_GENERAL_ADMISSIONS_SEATS_USED`;
const SET_GENERAL_ADMISSIONS_SEATS_USED = `${prefix}/SET_GENERAL_ADMISSIONS_SEATS_USED`;
const SET_HALL_ENTITY_ID = `${prefix}/SET_HALL_ENTITY_ID`;
const SET_HALL_HASH = `${prefix}/SET_HALL_HASH`;
const CHANGE_HALL_OPTIMIZED = `${prefix}/CHANGE_HALL_OPTIMIZED`;
const INITIALIZE_HALL = `${prefix}/INITIALIZE_HALL`;
const RESET_MODELS = `${prefix}/RESET_MODELS`;
const DELETE_OBJECT = `${prefix}/DELETE_OBJECT`;
const ENABLE_OBJECT = `${prefix}/ENABLE_OBJECT`;
const DISABLE_OBJECT = `${prefix}/DISABLE_OBJECT`;
const REINDEX_CHILDREN = `${prefix}/REINDEX_CHILDREN`;
const SET_SEAT_PURCHASE_STATUS = `${prefix}/SET_SEAT_PURCHASE_STATUS`;
const SET_SEATS_PURCHASE_STATUSES = `${prefix}/SET_SEATS_PURCHASE_STATUSES`;
const CALCULATE_HALL_CACHE_KEY = `${prefix}/CALCULATE_HALL_CACHE_KEY`;
const SET_OBJECT_FOR_CASHIER = `${prefix}/SET_OBJECT_FOR_CASHIER`;
const COMPILE_SECTOR = `${prefix}/COMPILE_SECTOR`;
const COMPILE_ROW = `${prefix}/COMPILE_ROW`;
const COMPILE_SEAT = `${prefix}/COMPILE_SEAT`;
const COMPILE_ROUND_TABLE = `${prefix}/COMPILE_ROUND_TABLE`;
const COMPILE_RECTANGLE_TABLE = `${prefix}/COMPILE_RECTANGLE_TABLE`;
const COMPILE_GENERAL_ADMISSION = `${prefix}/COMPILE_GENERAL_ADMISSION`;
const COMPILE_SHAPE = `${prefix}/COMPILE_SHAPE`;
const SELECT_SEATS = `${prefix}/SELECT_SEATS`;
const UNSELECT_SEATS = `${prefix}/UNSELECT_SEATS`;
const CREATE_SECTOR_WITH_ROWS_AND_SEATS = `${prefix}/CREATE_SECTOR_WITH_ROWS_AND_SEATS`;
const PUSH_ROW = `${prefix}/PUSH_ROW`;
const SCALE_ROUND_TABLE_DOWN = `${prefix}/SCALE_ROUND_TABLE_DOWN`;
const SCALE_ROUND_TABLE_UP = `${prefix}/SCALE_ROUND_TABLE_UP`;
const SCALE_RECTANGLE_TABLE_UP = `${prefix}/SCALE_RECTANGLE_TABLE_UP`;
const SCALE_RECTANGLE_TABLE_DOWN = `${prefix}/SCALE_RECTANGLE_TABLE_DOWN`;
const CREATE_RECTANGLE_TABLE_WITH_SEATS = `${prefix}/CREATE_RECTANGLE_TABLE_WITH_SEATS`;
const CREATE_ROUND_TABLE_WITH_SEATS = `${prefix}/CREATE_ROUND_TABLE_WITH_SEATS`;
const REMOVE_SEATS_FROM_RECTANGLE_TABLE = `${prefix}/REMOVE_SEATS_FROM_RECTANGLE_TABLE`;
const REMOVE_LAST_ROUND_TABLE_SEAT = `${prefix}/REMOVE_LAST_ROUND_TABLE_SEAT`;
const CREATE_SEATS_FOR_RECTANGLE_TABLE = `${prefix}/CREATE_SEATS_FOR_RECTANGLE_TABLE`;
const CREATE_SEAT_FOR_ROUND_TABLE = `${prefix}/CREATE_SEAT_FOR_ROUND_TABLE`;
const ARC_OBJECTS = `${prefix}/ARC_OBJECTS`;
const CHANGE_LABEL_TEXT_POSITION = `${prefix}/CHANGE_LABEL_TEXT_POSITION`;
const CHANGE_LABEL_VISIBILITY = `${prefix}/CHANGE_LABEL_VISIBILITY`;
const SET_TICKET_TYPE_SEATINGS_COUNT = `${prefix}/SET_TICKET_TYPE_SEATINGS_COUNT`;
const CREATE_RESERVATION = `${prefix}/CREATE_RESERVATION`;
const CHANGE_RESERVATION_NAME = `${prefix}/CHANGE_RESERVATION_NAME`;
const RESERVE_SEATINGS = `${prefix}/RESERVE_SEATINGS`;
const DISCARD_SEATINGS_RESERVATION = `${prefix}/DISCARD_SEATINGS_RESERVATION`;
const DELETE_RESERVATION = `${prefix}/DELETE_RESERVATION`;
const CALCULATE_RESERVATION_CAPACITY = `${prefix}/CALCULATE_RESERVATION_CAPACITY`;
const CALCULATE_OBJECTS_LINKING_POSITIONS = `${prefix}/CALCULATE_OBJECTS_LINKING_POSITIONS`;

export {
    CREATE_HALL,
    CREATE_GENERAL_ADMISSION,
    CALCULATE_GENERAL_ADMISSION_CACHE_KEY,
    SELECT_SEAT,
    UNSELECT_SEAT,
    MOVE_OBJECT,
    CHANGE_OBJECT_NAME,
    CHANGE_SHAPE_TYPE,
    ROTATE_OBJECT,
    POP_SEAT,
    PUSH_SEAT,
    SHIFT_SEAT,
    SHIFT_ROW,
    POP_ROW,
    UNSHIFT_SEAT,
    UNSHIFT_ROW,
    RESOLVE_SEAT_TRANSLATION,
    RESIZE_GENERAL_ADMISSION,
    CREATE_SHAPE,
    RESIZE_SHAPE,
    SET_OBJECT_CONFIGURATION,
    CHANGE_ROUND_TABLE_GAPS,
    SET_TABLE_AUTO_SCALE,
    SET_GENERAL_ADMISSION_CAPACITY,
    SET_HALL_ENTITY_ID,
    INITIALIZE_HALL,
    SET_HALL_HASH,
    CHANGE_HALL_OPTIMIZED,
    DELETE_OBJECT,
    ENABLE_OBJECT,
    DISABLE_OBJECT,
    REINDEX_CHILDREN,
    SET_SEAT_PURCHASE_STATUS,
    CALCULATE_HALL_POLYGON,
    CALCULATE_SECTOR_SHELLS,
    RESET_MODELS,
    CALCULATE_HALL_CACHE_KEY,
    SET_OBJECT_FOR_CASHIER,
    COMPILE_SECTOR,
    COMPILE_ROW,
    COMPILE_SEAT,
    COMPILE_GENERAL_ADMISSION,
    COMPILE_RECTANGLE_TABLE,
    COMPILE_ROUND_TABLE,
    COMPILE_SHAPE,
    SELECT_SEATS,
    UNSELECT_SEATS,
    CREATE_SECTOR_WITH_ROWS_AND_SEATS,
    PUSH_ROW,
    SCALE_ROUND_TABLE_DOWN,
    SCALE_ROUND_TABLE_UP,
    SCALE_RECTANGLE_TABLE_UP,
    SCALE_RECTANGLE_TABLE_DOWN,
    CREATE_RECTANGLE_TABLE_WITH_SEATS,
    CREATE_ROUND_TABLE_WITH_SEATS,
    REMOVE_SEATS_FROM_RECTANGLE_TABLE,
    CREATE_SEATS_FOR_RECTANGLE_TABLE,
    REMOVE_LAST_ROUND_TABLE_SEAT,
    ARC_OBJECTS,
    CREATE_SEAT_FOR_ROUND_TABLE,
    CHANGE_LABEL_TEXT_POSITION,
    CHANGE_LABEL_VISIBILITY,
    SET_TICKET_TYPE_SEATINGS_COUNT,
    SET_SEATS_PURCHASE_STATUSES,
    INCREMENT_GENERAL_ADMISSIONS_SEATS_USED,
    SET_GENERAL_ADMISSIONS_SEATS_USED,
    CREATE_RESERVATION,
    CHANGE_RESERVATION_NAME,
    RESERVE_SEATINGS,
    DISCARD_SEATINGS_RESERVATION,
    DELETE_RESERVATION,
    CALCULATE_RESERVATION_CAPACITY,
    CALCULATE_OBJECTS_LINKING_POSITIONS,
};
